//@flow
import { ILanguage } from "../action/types";
import {
  LIBRARY_GET_RECOMMENDED_REQUESTING,
  LIBRARY_GET_ALL_REQUESTING,
  LIBRARY_GET_PREMIUM_REQUESTING,
  LIBRARY_CLICK_TOPIC,
  LIBRARY_TOPIC_FEEDBACK_IDEA_CHANGE,
  LIBRARY_SUBMIT_TOPIC_FEEDBACK_REQUESTING,
} from "./constants";

export const getAllCampaignsRequest = (payload: { clientId: string }) => {
  return {
    type: LIBRARY_GET_ALL_REQUESTING,
    payload,
  };
};

export const getPremiumCampaignsRequest = (payload: { clientId: string }) => {
  return {
    type: LIBRARY_GET_PREMIUM_REQUESTING,
    payload,
  };
};

export const getRecommendedCampaignsRequest = (payload: {
  clientId: string;
  userId: string;
}) => {
  return {
    type: LIBRARY_GET_RECOMMENDED_REQUESTING,
    payload,
  };
};

export const clickTopic = (payload: { value: string; title: ILanguage }) => {
  return {
    type: LIBRARY_CLICK_TOPIC,
    payload,
  };
};

export const onChangeTopicFeedbackIdea = (payload: string) => {
  return {
    type: LIBRARY_TOPIC_FEEDBACK_IDEA_CHANGE,
    payload,
  };
};

export const submitLibraryFeedbackRequest = (payload: {
  clientId: string;
  userId: string;
  topicIdea: string;
  topicChoices: [];
}) => {
  return {
    type: LIBRARY_SUBMIT_TOPIC_FEEDBACK_REQUESTING,
    payload,
  };
};
